var ltr6_module_panzoom = (function (ltr6_module_panzoom) {
    
    // var radarRect = {x:376,y:361,width:1575,height:1127};
    var radarRect = {x:0,y:0,width:2000,height:1992};

    ltr6_module_panzoom.smoothFitLandingRadar = function(){
      ltr6_module_panzoom.panzoomLanding.smoothFitRect(radarRect,0,500);
    };
    ltr6_module_panzoom.fitLandingRadar = function(){
      ltr6_module_panzoom.panzoomLanding.fitRect(radarRect,0,500);
    };

    ltr6_module_panzoom.init = function(){






      // document.addEventListener('gesturestart', function(e) {
      //     e.preventDefault();
      //     // special hack to prevent zoom-to-tabs gesture in safari
      //     document.body.style.zoom = 0.99;
      // });

      // document.addEventListener('gesturechange', function(e) {
      //     e.preventDefault();
      //     // special hack to prevent zoom-to-tabs gesture in safari
      //     document.body.style.zoom = 0.99;
      // });

      // document.addEventListener('gestureend', function(e) {
      //     e.preventDefault();
      //     // special hack to prevent zoom-to-tabs gesture in safari
      //     document.body.style.zoom = 0.99;
      // });
      
      var touchedNode = null;
      $('#ltr6-wrapper .ltr6-radar-view .ltr6-radar-panzoom').on('touchstart', function(e) {

      });

      $('#ltr6-wrapper .ltr6-radar-view .ltr6-radar-panzoom').on('touchmove', function(e) {
        e.preventDefault();
      });










      function scaleNodes(radarInstance,scale){
        // console.log('node prescale',scale);
        if(scale<0.46) scale = 0.46; // min scale
        if(scale>2) scale = 2; // max scale
        $('.ltr6-radar-view .ltr6-node',radarInstance).css('transform','scale('+(1/scale)+')');          
      }


      // ============================================================
      // landing page panzoom
      // ============================================================
      if($('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view .ltr6-radar-panzoom').length){
          // $('#ltr6-wrapper .ltr6-interactive-radar .ltr6-radar-view .ltr6-radar-panzoom').addClass('loading');

        ltr6_module_panzoom.panzoomLanding = new Panzoom('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view .ltr6-radar-panzoom',{
          // bound: 'inner', // contain,cover,inner - contain: edges wont go outside viewport, cover: map always fills viewport, inner: as contain but for opposite edge, none
          bound: 'cover', // contain,cover,inner - contain: edges wont go outside viewport, cover: map always fills viewport, inner: as contain but for opposite edge, none
          innerPadding: 0, // for inner bound mode only - how much of the map stays on viewport before limit
          startScale: 1, //starting scale
          minScale: 0.05, //minimum zoom scale
          maxScale: 3, //maximum zoom scale
          transitionDuration: 400, //transition duration
          inertiaFriction: 0.85, //after-drag inertia
          inertiaBounce: 0.2, //after-drag bounce effect at edges
          wheel_step: 0.5, //mouse scroll wheel speed
          doubleClickZoom: false, //enable double click to zoom feature
          doubleClickZoomFitChildren: false, //zoom to fit rect a child element on double click (this always works if has class 'panzoom_double_click_zoom')
          doubleClickTime: 250, //speed ms to capture double click
          useShiftKey: true, //whether to require the shift key to be pressed to zoom.
          useShiftKeyCallbackThrottle: 5000, //throttle the event - how long to wait before firing the next showShifyKey event.
          restrictClickToParent: false, //restrict click handler to the parent. Sometimes needed if overflow is visible, prevents clicking and dragging children.
        });

        // ltr6_module_panzoom.panzoomLanding.center();
        // ltr6_module_panzoom.panzoomLanding.smoothFit();
        // ltr6_module_panzoom.panzoomLanding.fit();
        // ltr6_module_panzoom.panzoomLanding.fitRect({x:574,y:0,width:1575,height:1127});
        // ltr6_module_panzoom.panzoomLanding.smoothCenter();
        // ltr6_module_panzoom.panzoomLanding.fitRect(radarRect);

      ltr6_module_panzoom.panzoomLanding.dirty = false;

        // ltr6_module_panzoom.panzoomLanding.zoomBy(0.3);
        setTimeout(function(){
          var dist = 20;
          ltr6_module_panzoom.panzoomLanding.fitRect({x:radarRect.x+dist,y:radarRect.y+dist,width:radarRect.width-(dist*2),height:radarRect.height-(dist*2)});
          // ltr6_module_panzoom.panzoomLanding.smoothFitRect(radarRect,500);
          scaleNodes($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'),ltr6_module_panzoom.panzoomLanding.scale);
          $('#ltr6-wrapper .ltr6-interactive-radar .ltr6-radar-view .ltr6-radar-panzoom').removeClass('loading');
        },20);

        setTimeout(function(){
          // ltr6_module_panzoom.panzoomLanding.center();
          // ltr6_module_panzoom.panzoomLanding.smoothFitRect(radarRect,500);

          // fix to scale the nodes on startup glitch
          // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view .ltr6-node').css('transform','scale('+(1/ltr6_module_panzoom.panzoomLanding.scale)+')');
          scaleNodes($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'),ltr6_module_panzoom.panzoomLanding.scale);
        },40);


        ltr6_module_panzoom.panzoomLanding.on("useShiftKey", function(e) {
          // var useShiftKeyOverlay = document.querySelectorAll('.useShiftKey')[0];
          // useShiftKeyOverlay.classList.add("active");
          useShiftKeyOverlay = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view .ltr6-use-shift-key-overlay');
          useShiftKeyOverlay.addClass('active');
          setTimeout(function(){
          useShiftKeyOverlay.removeClass('active');
            // useShiftKeyOverlay.classList.remove("active");
          }, 1000);
          // console.log('use the shift key!',e.detail,e);
        });


        // scale nodes
        
        // function scaleNodes(scale){
        //   // console.log('node prescale',scale);

        //   if(scale<0.50) scale = 0.50;
        //   if(scale>1) scale = 1;
        //   $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view .ltr6-node').css('transform','scale('+(1/scale)+')');          
        // }

        ltr6_module_panzoom.panzoomLanding.on("update", function(e) {
          var scale = e.detail.scale;
          scaleNodes($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'),scale);
        });


        $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-panzoom-controls').on('click', 'a[data-ltr6-panzoom-action="zoom_in"]', function(event) {
          event.preventDefault();
          ltr6_module_panzoom.panzoomLanding.smoothZoomBy(0.2,200);
          ltr6_module_panzoom.panzoomLanding.dirty = true;
        });

        $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-panzoom-controls').on('click', 'a[data-ltr6-panzoom-action="zoom_out"]', function(event) {
          event.preventDefault();
          ltr6_module_panzoom.panzoomLanding.smoothZoomBy(-0.2,200);
          ltr6_module_panzoom.panzoomLanding.dirty = true;
        });

        $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-panzoom-controls').on('click', 'a[data-ltr6-panzoom-action="reset"]', function(event) {
          event.preventDefault();
          ltr6_module_panzoom.panzoomLanding.smoothFitRect(radarRect);
          ltr6_module_panzoom.panzoomLanding.dirty = false;
        });



        // // ==========================================
        // // HOLD TO ZOOM VERSION, 200ms click detect
        // // ==========================================
        // var clickDetect = 200;
        // var uglyZoomSpeed = 50;

        // var mouseDownInterval,mouseDownTimeout;
        // var zooming = false;
        // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-bottom-controls').on('mousedown', 'a[data-ltr6-panzoom-action="zoom_in"]', function(event) {
        //   zooming = true;
        //   clearInterval(mouseDownInterval);
        //   mouseDownInterval = setInterval(function(){
        //     ltr6_module_panzoom.panzoomLanding.smoothZoomBy(0.03,uglyZoomSpeed);
        //   },uglyZoomSpeed);
        //   clearTimeout(mouseDownTimeout);
        //   mouseDownTimeout = setTimeout(function(){
        //     if(!zooming) ltr6_module_panzoom.panzoomLanding.smoothZoomBy(0.2);
        //   }, clickDetect);
        // });
        // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-bottom-controls').on('mouseup', 'a[data-ltr6-panzoom-action="zoom_in"]', function(event) {
        // // $(document).on('mouseup', function(event) {
        //   if(zooming){
        //     clearInterval(mouseDownInterval);
        //     zooming = false;
        //   }
        // });



        // var mouseUpInterval,mouseUpTimeout;
        // var zooming = false;
        // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-bottom-controls').on('mousedown', 'a[data-ltr6-panzoom-action="zoom_out"]', function(event) {
        //   zooming = true;
        //   clearInterval(mouseUpInterval);
        //   mouseUpInterval = setInterval(function(){
        //     ltr6_module_panzoom.panzoomLanding.smoothZoomBy(-0.03,uglyZoomSpeed);
        //   },uglyZoomSpeed);
        //   clearTimeout(mouseUpTimeout);
        //   mouseUpTimeout = setTimeout(function(){
        //     if(!zooming) ltr6_module_panzoom.panzoomLanding.smoothZoomBy(-0.2);
        //   }, clickDetect);
        // });
        // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-bottom-controls').on('mouseup', 'a[data-ltr6-panzoom-action="zoom_out"]', function(event) {
        // // $(document).on('mouseup', function(event) {
        //   if(zooming){
        //     clearInterval(mouseUpInterval);
        //     zooming = false;
        //   }
        // });


        
        // sticky top controls

        var stickyControls = ltr6_module_utilities.debounce(function(e) {
          stickTheControls();
        }, 10);
        // window.addEventListener('scroll', stickyControls);
        $(window).on('scroll', stickyControls);
        $(window).on('touchmove', stickyControls);
        stickTheControls();
        function stickTheControls(){
          // var headerHeight = $('#navigation-primary > .c-nav').height();
          // var ltr6HeaderHeight = $('#ltr6-navigation').height();
          // var subSectionHeaderHeight = $('.secondaryNavIparsys').height();
          var offset = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar').offset();

          var radarTop = offset.top - 54;

          var hh = $('body .l-view header').height();

          // var width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          // if(width<768) {
          //   radarTop = 0;
          // }
          // console.log('offset',offset);

          // console.log('sticky controls');
            var scrollTop = $(window).scrollTop();
            var topControls = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-top-left-controls');
            var bottomControls = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-top-right-controls');
            var diff = 0;
            if(scrollTop>radarTop){
              // diff = scrollTop - 190 + 85;
              // diff = scrollTop - 190;
              // diff = scrollTop - radarTop;
              diff = scrollTop - (hh - 105);
              
              // for v2
              if($('html').hasClass('full-width-grid')){
                diff = scrollTop - (hh - 5);
                if($('#ltr6-navigation').hasClass('self-standing')){
                  diff = scrollTop - (hh - 55);
                }
              }

              // var width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
              // if(width<768){
              //   diff = scrollTop - (86);              
              // }

            } else {
              diff = 0;
            }
            if(scrollTop>830) diff = 670;
            // if(scrollTop>830) diff = scrollTop;


            topControls.css('margin-top',diff+ 'px');
            bottomControls.css('margin-top',diff+ 'px');
            // $('.ltr6-filters-col').css('margin-top',diff+ 'px');
        }






      }




      // ============================================================
      // navigation panzoom
      // ============================================================

      ltr6_module_panzoom.panzoomNavigation = new Panzoom('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-view .ltr6-radar-panzoom',{
        // bound: 'inner', // contain,cover,inner - contain: edges wont go outside viewport, cover: map always fills viewport, inner: as contain but for opposite edge, none
        bound: 'cover', // contain,cover,inner - contain: edges wont go outside viewport, cover: map always fills viewport, inner: as contain but for opposite edge, none
        innerPadding: 0, // for inner bound mode only - how much of the map stays on viewport before limit
        startScale: 1, //starting scale
        minScale: 0.05, //minimum zoom scale
        maxScale: 3, //maximum zoom scale
        transitionDuration: 400, //transition duration
        inertiaFriction: 0.85, //after-drag inertia
        inertiaBounce: 0.2, //after-drag bounce effect at edges
        wheel_step: 0.5, //mouse scroll wheel speed
        doubleClickZoom: false, //enable double click to zoom feature
        doubleClickZoomFitChildren: false, //zoom to fit rect a child element on double click (this always works if has class 'panzoom_double_click_zoom')
        doubleClickTime: 250, //speed ms to capture double click
        useShiftKey: true, //whether to require the shift key to be pressed to zoom.
        useShiftKeyCallbackThrottle: 5000, //throttle the event - how long to wait before firing the next showShifyKey event.
        restrictClickToParent: false, //restrict click handler to the parent. Sometimes needed if overflow is visible, prevents clicking and dragging children.
      });

      // ltr6_module_panzoom.panzoomNavigation.center();
      // ltr6_module_panzoom.panzoomNavigation.smoothFit();
      // ltr6_module_panzoom.panzoomNavigation.fit();
      // ltr6_module_panzoom.panzoomNavigation.fitRect({x:574,y:0,width:1575,height:1127});
      // ltr6_module_panzoom.panzoomNavigation.fitRect(radarRect);
      // ltr6_module_panzoom.panzoomNavigation.smoothCenter();

      ltr6_module_panzoom.panzoomNavigation.dirty = false;


      ltr6_module_panzoom.panzoomNavigation.on("useShiftKey", function(e) {
        // var useShiftKeyOverlay = document.querySelectorAll('.useShiftKey')[0];
        // useShiftKeyOverlay.classList.add("active");
        useShiftKeyOverlay = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-view .ltr6-use-shift-key-overlay');
        useShiftKeyOverlay.addClass('active');
        setTimeout(function(){
        useShiftKeyOverlay.removeClass('active');
          // useShiftKeyOverlay.classList.remove("active");
        }, 1000);
        // console.log('use the shift key!',e.detail,e);
      });

      // fix to scale the nodes on startup glitch
      // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-view .ltr6-node').css('transform','scale('+(1/ltr6_module_panzoom.panzoomNavigation.scale)+')');
      
      //scale on load
      scaleNodes($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'),ltr6_module_panzoom.panzoomNavigation.scale);

      // scale nodes
      // ltr6_module_panzoom.panzoomNavigation.on("update", function(e) {
      //   var scale = e.detail.scale;
      //   console.log(scale);
      //   // if(scale<0.55) return false;
      //   // if(scale>1) return false;
      //   $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-view .ltr6-node').css('transform','scale('+(1/scale)+')');
      // });
      // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-view .ltr6-node').css('transform','scale('+(1/ltr6_module_panzoom.panzoomNavigation.scale)+')');
      ltr6_module_panzoom.panzoomNavigation.on("update", function(e) {
        var scale = e.detail.scale;
        scaleNodes($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'),scale);
      });


      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-panzoom-controls').on('click', 'a[data-ltr6-panzoom-action="zoom_in"]', function(event) {
        event.preventDefault();
        ltr6_module_panzoom.panzoomNavigation.smoothZoomBy(0.2,200);
        ltr6_module_panzoom.panzoomNavigation.dirty = true;
      });

      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-panzoom-controls').on('click', 'a[data-ltr6-panzoom-action="zoom_out"]', function(event) {
        event.preventDefault();
        ltr6_module_panzoom.panzoomNavigation.smoothZoomBy(-0.2,200);
        ltr6_module_panzoom.panzoomNavigation.dirty = true;
      });

      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-panzoom-controls').on('click', 'a[data-ltr6-panzoom-action="reset"]', function(event) {
        event.preventDefault();
        ltr6_module_panzoom.panzoomNavigation.smoothFitRect(radarRect);
        ltr6_module_panzoom.panzoomNavigation.dirty = false;
      });





      // // =====================================================================
      // // fit the radar on width changes
      // // =====================================================================
      // var oldWidthState;
      // var rescaleOnWidthChange = ltr6_module_utilities.debounce(function() {
      //   var width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      //   var currentWidthState;

      //   var s1 = 0;
      //   if(ltr6_module_panzoom.panzoomLanding){
      //     s1 = ltr6_module_panzoom.panzoomLanding.scale;
      //   }
      //   var s2 = ltr6_module_panzoom.panzoomNavigation.scale;
      //   if(Math.max(s1,s2)>0.55) return;

      //   // var height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
      //   if(width>1375){
      //     currentWidthState = 7;
      //   } else if(width>1200){
      //     currentWidthState = 6;
      //   } else if(width>1000){
      //     currentWidthState = 5;
      //   } else if(width>768){
      //     currentWidthState = 4;
      //   } else if(width>600){
      //     currentWidthState = 3;
      //   } else if(width>425){
      //     currentWidthState = 2;
      //   } else if(width>340){
      //     currentWidthState = 1;
      //   } else {
      //     currentWidthState = 0;
      //   }
      //   if(oldWidthState!=currentWidthState){
      //     console.log('centering radar due to width change');
      //     if(ltr6_module_panzoom.panzoomLanding){
      //       ltr6_module_panzoom.panzoomLanding.smoothFitRect(radarRect,500);
      //     }
      //     ltr6_module_panzoom.panzoomNavigation.smoothFitRect(radarRect,500);
      //   }
      //   oldWidthState = currentWidthState;
      // }, 50);
      // window.addEventListener('resize', rescaleOnWidthChange);



      // =====================================================================
      // fit the radar on width changes
      // =====================================================================
      // the above does state checks - pointless, just rely on debounce is fine.
      function viewport() {
          var e = window, a = 'inner';
          if (!('innerWidth' in window )) {
              a = 'client';
              e = document.documentElement || document.body;
          }
          return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
      }

      var rescaleOnWidthChange2 = function() {
        rescaleRadarView();
        if(ltr6_module_panzoom.panzoomLanding && ltr6_module_panzoom.panzoomLanding.dirty==false){
          ltr6_module_panzoom.panzoomLanding.smoothFitRect(radarRect);
        }

        // if(ltr6_module_panzoom.panzoomNavigation.dirty==false) {
        //   ltr6_module_panzoom.panzoomNavigation.smoothFitRect(radarRect);
        // }
      };

      var rescaleOnWidthChangeDebounced = ltr6_module_utilities.debounce(rescaleOnWidthChange2, 100);


      // resize the radar view to fit in available screen space vertically
      var rescaleRadarView = function() {
        // var headerHeight = $('.l-view > header').height();
        // var browserHeight = $(window).height();
        // var paddingHeight = 0;
        // var ltrNavigationHeight = $('#ltr6-wrapper .ltr6-navigation').height();
        // var offset = $('#ltr6-wrapper .ltr6-interactive-radar .ltr6-radar-view').offset().top;
        // var view = viewport();
        // if(view.width < 768) browserHeight -= 200; // allow for the top padding of doc when mobile header sticky
        // var finalHeight = browserHeight - offset;
        // if(finalHeight<600) finalHeight = 600;
        // $('#ltr6-wrapper .ltr6-interactive-radar .ltr6-radar-view').height((finalHeight) + 'px');

        var radarViewWidth = $('#ltr6-wrapper .ltr6-interactive-radar .ltr6-radar-view').width();
        var filterColHeight = $('#ltr6-wrapper .ltr6-interactive-radar .ltr6-filters-col').height();
        var headerHeight = 70; // size of the header
        var browserHeight = $(window).height();
        var finalHeight = browserHeight - headerHeight;

        var view = viewport();
        if(view.width >= 768){
          //desktop
          if(finalHeight<600) finalHeight = 600;
          if(finalHeight>radarViewWidth) finalHeight = radarViewWidth; 
        } else {
          //mobile
          if(finalHeight>radarViewWidth*1.3) finalHeight = radarViewWidth*1.3; 
          if(finalHeight<300) finalHeight = 300;
        }
        // if(browserHeightfinalHeight<filterColHeight) finalHeight = filterColHeight;

        $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar .ltr6-radar-view').height((finalHeight) + 'px');


        console.log('radarViewWidth',radarViewWidth);
        console.log('finalHeight',finalHeight);
      };
      // var rescaleRadarViewDebounced = ltr6_module_utilities.debounce(rescaleRadarView, 100);


      // window.addEventListener('resize', rescaleRadarViewDebounced);
      rescaleRadarView();

      setTimeout(function(){
        if(ltr6_module_panzoom.panzoomLanding) ltr6_module_panzoom.panzoomLanding.fitRect(radarRect);
        ltr6_module_panzoom.panzoomNavigation.fitRect(radarRect);
        window.addEventListener('resize', rescaleOnWidthChangeDebounced);
      },100);


      // // go to trend 
      // setTimeout(function(){
      //   ltr6_module_panzoom.goToTrend('alternative-energy-solutions');
      // },1000);


    }; //end init


    ltr6_module_panzoom.goToTrend = function(trendSlug){
      

        // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-panzoom .ltr6-node').removeClass('highlighted');
        // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-panzoom .ltr6-node').addClass('disabled');
        var target = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="'+trendSlug+'"]');

        // target.addClass('highlighted');
        // target.removeClass('disabled');
        var box = target[0].getBoundingClientRect();
        var x = trends_data[trendSlug].x;
        var y = trends_data[trendSlug].y;
        console.log('box',trends_data[trendSlug].x);
        // ltr6_module_panzoom.panzoomNavigation.smoothPanToPoint(x,y,1);
        ltr6_module_panzoom.panzoomNavigation.panToPoint(x,y,0.9);

        // scaleNodes($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'),ltr6_module_panzoom.panzoomNavigation.scale);
        var scale = ltr6_module_panzoom.panzoomNavigation.scale;
        if(scale<0.50) scale = 0.50;
        if(scale>1) scale = 1;
        $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-view .ltr6-node').css('transform','scale('+(1/scale)+')');          

        ltr6_module_navigation.openRadarPanel();

        setTimeout(function(){
          // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-panzoom .ltr6-node').removeClass('highlighted');
          // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-panzoom .ltr6-node').addClass('disabled');
          ltr6_module_panzoom.panzoomNavigation.smoothFit(2000);
        },500);
        setTimeout(function(){
          target.addClass('highlighted');
          target.removeClass('disabled');

        },501);

        // ltr6_module_panzoom.panzoomNavigation.smoothFitRect(radarRect);
    };





    return ltr6_module_panzoom;
}(ltr6_module_panzoom || {}));